import classnames from 'classnames';

import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import { getPastPeriod, PastPeriod } from 'Utils/LastActivityTime';
import HumanDate, { ShowYear } from 'src/components/HumanDate';
import translation from 'src/components/translation';
import { REGULAR_SPACE } from 'src/utils/constants/symbols';

import styles from './index.less';

const PAST_PERIODS_UP_TO_WEEK = [PastPeriod.FewDays, PastPeriod.Week];

const TrlKeys = {
    updated: 'employer.resumesSearch.updated',
};

interface Props {
    date: number;
}

const LastChangeTime: TranslatedComponent<Props> = ({ date, trls }) => {
    const hasChangedInPastWeek = PAST_PERIODS_UP_TO_WEEK.includes(getPastPeriod(date));

    return (
        <span
            suppressHydrationWarning
            className={classnames({
                [styles.dateHighlight]: hasChangedInPastWeek,
            })}
        >
            {trls[TrlKeys.updated]}
            {REGULAR_SPACE}
            <HumanDate date={date} showYear={ShowYear.NotCurrent} />
        </span>
    );
};

export default translation(LastChangeTime);
